import React from "react";
import FormComponent from "../Form/FormComponent";
// import { UpdateEmailContact } from "../Campaign/campaignQueries";
import { Dialog } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import "./AddLinkedin.css";
import Edit from "../assets/pencil.png";
// import store from "../../Redux/Store";
// import { updateCustomerLinkedinCreate } from "../Customers/Customerquery";
import * as Yup from "yup";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;

  return (
    <MuiDialogTitle className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {}
}))(MuiDialogContent);

export default function CustomizedDialogs(props) {
  const [open, setOpen] = React.useState(
    props.showButton === false ? true : false
  );

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const renderModalContent = props => {
    return (
      <div className="EditEmail">
        <FormComponent
          editableData={props.editableData}
          formConfig={Editemail}
          formValidation={Editvalidation}
          modalClose={handleClose}
          buttonName={"Update"}
          message="Email updated successfully"
          query={props.query}
          updateData={props.updateData}
        />
      </div>
    );
    //}
  };

  return (
    <div>
      {/* <span
        title="Edit"
        style={{ cursor: "pointer", marginRight: "15px" }}
        onClick={handleClickOpen}
      >
        <img src={Edit} alt="Edit" />
      </span> */}
      <a
        title="Edit"
        style={{ cursor: "pointer", marginRight: "15px" }}
        onClick={handleClickOpen}
      >
        <img src={Edit} alt="Edit" />
      </a>

      <div>
        <Dialog aria-labelledby="customized-dialog-title" open={open}>
          <div className="Linkedin">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
              <div className="LinkedinTitle">Edit Email</div>
            </DialogTitle>
            <DialogContent>{renderModalContent(props)}</DialogContent>
          </div>
        </Dialog>
      </div>
    </div>
  );
}

const Editemail = {
  title: "Add New",
  fields: [
    {
      label: "Email",
      type: "input",
      placeholder: "e.g abc@gmail.com",
      isRequired: true,
      name: "email",
      value: ""
    }
  ]
};
const Editvalidation = Yup.object().shape({
  email: Yup.string()
    .required("Please enter email")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      {

        message: "Please enter a vaild email",
        excludeEmptyString: true
      }
    )
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(30, "Email should be less than 30 characters")
});
